import {remCalc} from '../../_utils'

/**
 * the out of stock component style
 */
export default {
    baseStyle: {
        icon: {
            color: 'white',
            fill: 'text.default',
            boxSize: remCalc(16),
            cursor: 'initial',
            borderRadius: remCalc(3),
            w: 'iconsSize.small',
            h: 'iconsSize.small',
        },
        text: {
            color: 'text.default',
            fontWeight: 'bold',
            marginTop: remCalc(2),
            marginLeft: remCalc(8),
            textAlign: 'center',
            textStyle: 'body-small',
        },
    },
    variants: {
        outOfStock: {
            icon: {fill: 'text.danger', backgroundColor: 'text.danger'},
            text: {color: 'text.danger'},
        },
        lastFewItems: {
            icon: {backgroundColor: 'text.default', color: 'text.inverse'},
        },
    },
    parts: ['icon', 'text'],
}
